import type { ShortVideo } from '~/composables/shorts/useFetchShorts';
import type { ShortsFilters } from '~/core/entities/property/filters';

interface ShortsEntryContext {
	items: ShortVideo[];
	filters: ShortsFilters;
	page: number;
	perPage?: number;
	hasMore: boolean;
	allWatched?: boolean;
}

/**
 * Estado transitório: itens do carrossel de origem ainda não exibidos no feed.
 * Preenchido antes de navegar para `/shorts/[commercialId]`; consumido no mount da página.
 * Permite que o feed continue a sequência do carrossel sem chamar a API para o primeiro "page".
 */
export function useShortsEntryContext() {
	return useState<ShortsEntryContext | null>(
		'shorts-entry-context',
		() => null
	);
}

/**
 * O ShortVideo exatamente clicado (ou tocado) que originou a navegação.
 * Separado do entry-context porque TODOS os fluxos de entrada podem
 * fornecê-lo (home/PDP/SRP), enquanto o contexto de seed do feed é
 * exclusivo do fluxo da SRP. Consumido uma única vez pela página.
 */
export function useShortsEntrySeedItem() {
	return useState<ShortVideo | null>('shorts-entry-seed-item', () => null);
}
